import { ref, watch } from 'vue'

export function useDisplay(props) {
  const visible = ref(false)
  const showRander = ref(false)
  const showEvent = () => {
    if (!showRander.value) {
      showRander.value = true
    }
    visible.value = true
  }
  const onCancel = () => {
    visible.value = false
  }

  watch(
    () => props.value,
    async () => {
      //当value的值发生变化时隐藏弹窗
      visible.value = false
    },
    {
      immediate: true,
    }
  )

  return {
    visible,
    showRander,
    showEvent,
    onCancel,
  }
}
